import Reveal from './Reveal';

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-cream py-28 lg:py-40 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16 lg:gap-24 items-center">
        <div className="lg:col-span-6 relative">
          <Reveal>
            <div className="relative">
              <div className="absolute -bottom-5 -right-5 w-full h-full border border-gold/50" aria-hidden="true" />
              <div
                className="relative w-full aspect-[4/5] bg-gold shadow-[0_8px_30px_rgb(0,0,0,0.08)]"
                data-testid="about-image-main"
              >
                <div className="absolute inset-0" style={{ clipPath: 'polygon(0 0, 56.5% 0, 28.5% 100%, 0 100%)' }}>
                  <img
                    src="https://images.unsplash.com/photo-1758072261887-4625db825420?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxDaGFwZWwlMjBIaWxsJTIwb2xkJTIwd2VsbHxlbnwwfHx8fDE3OTA5NjU0MDR8MA&ixlib=rb-4.1.0&q=85"
                    alt="The Old Well at UNC Chapel Hill"
                    data-testid="about-image-unc"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute inset-0" style={{ clipPath: 'polygon(58% 0, 100% 0, 100% 100%, 30% 100%)' }}>
                  <img
                    src="https://customer-assets-jai6qajn.emergentagent.net/job_tax-strategy-pro-1/artifacts/57a8f8b3ae39900c_Durham-Bull_WeWork_image3.jpg"
                    alt="Major, the Durham bull statue"
                    data-testid="about-image-duke"
                    className="absolute max-w-none"
                    style={{ width: '130%', height: 'auto', left: '24%', top: '0%' }}
                  />
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 mt-16 lg:mt-0">
          <Reveal>
            <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
              <span className="eyebrow-rule" />
              The firm
            </p>
            <h2 data-testid="about-heading" className="font-serif tracking-tight text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.08]">
              Counsel built on trust, kept for <span className="italic text-gold">decades.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-slateink font-light leading-relaxed text-base">
              A. G. Mangum &amp; Co. is a Chapel Hill tax advisory firm, comprised of experienced CPAs and EAs, serving individuals, business owners, executives, and health care professionals throughout Chapel Hill, Durham, and the surrounding communities. We believe good tax work is quiet, careful, and constant — not a once-a-year scramble.
            </p>
            <p className="mt-6 text-slateink font-light leading-relaxed text-base">
              Our clients stay because we know their practices as well as their returns: the associate becoming a partner, the dentist buying a first practice, the firm ready for its next stage of growth.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <dl className="mt-14 grid grid-cols-3 gap-8 border-t border-navy/10 pt-10">
              {[
                ['Chapel Hill', 'Since 1966'],
                ['Year-round', 'Planning, not scrambling'],
                ['Practices', 'Medical, dental & beyond'],
              ].map(([term, desc]) => (
                <div key={term}>
                  <dt className="font-serif text-navy text-xl lg:text-2xl tracking-tight">{term}</dt>
                  <dd className="text-xs tracking-[0.15em] uppercase text-slateink/70 mt-2">{desc}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
